
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import LinearProgress from '@material-ui/core/LinearProgress';
import Tooltip from '@material-ui/core/Tooltip';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FadeIn from 'react-fade-in';
var show_middle = false
var show_nw_nps_os = false


class Chart2 extends Component {
	constructor() {
		super();
		this.state = {
			data: null,
			mid_count: 0
		}
	}
	componentDidMount() {
		show_middle = false
		show_nw_nps_os = false
		Alert.Loading(true)
		var where = {
			mid_nps: this.props.mid_nps
		}
		if (this.props.quarter_number) where.quarter_number = this.props.quarter_number
		if (this.props.dealer_code_list) where.dealer_code_list = this.props.dealer_code_list

		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L3, where, ({ datas }) => {
			var mid_count = 0
			datas.map((row) => {
				mid_count += row.count_100_per || 0
			})
			this.setState({
				mid_count: mid_count,
				data: datas.sort(function (a, b) { return parseFloat(b.nps_os_current) - parseFloat(a.nps_os_current) })
			}, () => {
				Alert.LoadingClose()
			})
		})
	}
	renderLabelData(name, count_100_per, value, old_value, isPass = false, middle = false) {
		var _value = value
		return <div>
			<GridContainer justify="center">
				<GridItem xs={6}>
					{
						(middle) ?
							<Typography variant="body2" align="left" className={"linearProgress-c-gy-txt"} >{this.renderTooltip(name)}</Typography>
							:
							(isPass) ?
								<Typography variant="body2" align="left" className={"linearProgress-c-gn-txt"} >{this.renderTooltip(name)}</Typography>
								:
								<Typography variant="body2" align="left" className={"linearProgress-c-r-txt"}>{this.renderTooltip(name)}</Typography>
					}
				</GridItem>
				<GridItem xs={1}>
					<center>
						{
							(middle) ?
								<Typography variant="body2" align="right" className={"linearProgress-c-gy-txt"} >N:{count_100_per}</Typography>
								:
								(isPass) ?
									<Typography variant="body2" align="right" className={"linearProgress-c-gn-txt"} >N:{count_100_per}</Typography>
									:
									<Typography variant="body2" align="right" className={"linearProgress-c-r-txt"}>N:{count_100_per}</Typography>
						}
					</center>
				</GridItem>
				<GridItem xs={2}>
					<Box display="flex" alignItems="center">
						<Box width="100%" mr={1}>
							{
								(middle) ?
									<LinearProgress variant="determinate" className={"linearProgress-c-gy"} valueBuffer={0} value={_value} />
									:
									(isPass) ?
										<LinearProgress variant="determinate" className={"linearProgress-c-gn"} valueBuffer={0} value={_value} />
										:
										<LinearProgress variant="determinate" className={"linearProgress-c-r"} valueBuffer={0} value={_value} />
							}

						</Box>
						<Box minWidth={35}>
							{
								(middle) ?
									<Typography variant="body2" className={"linearProgress-c-gy-txt"} align="right"  >{`${Math.round(_value)}%`}</Typography>
									:
									(isPass) ?
										<Typography variant="body2" className={"linearProgress-c-gn-txt"} align="right" >{`${Math.round(_value)}%`}</Typography>
										:
										<Typography variant="body2" className={"linearProgress-c-r-txt"} align="right" >{`${Math.round(_value)}%`}</Typography>
							}
						</Box>
					</Box>
				</GridItem>
				<GridItem xs={3}>
					<GridContainer justify="center">
						<GridItem><Typography variant="body2" align="right" >{Math.round(0)}%</Typography></GridItem>
						<GridItem><Typography variant="body2" align="right" >{Math.round(0)}%</Typography></GridItem>
						<GridItem><Typography variant="body2" align="right" >{Math.round(0)}%</Typography></GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
		</div>
	}
	renderTooltip = (str) => {
		var _str = str
		// if (str.length > 40) {
		// 	_str = str.substring(0, 40) + "..."
		// }
		return (
			<Tooltip title={str} arrow placement="top">
				<div>{_str}</div>
			</Tooltip>
		)
	}
	render() {
		return (
			<div className={"p-1 chart-box"}>
				<div>
					<GridContainer justify="center">
						<GridItem xs={9} className="m-b-1">
							{
								this.props.dealerTypeChart ?
									<h4 className="m-t-0"><b> Nationwide NPS-OS </b>: Quarter {this.props.quarter_number}/{this.props.quarter_number == 2 || this.props.quarter_number == 3 ? "21" : "22"} </h4>
									:
									<h4 className="m-t-0"><b>  NPS by Dealer  </b>: Quarter {this.props.quarter_number}/{this.props.quarter_number == 2 || this.props.quarter_number == 3 ? "21" : "22"} / From area {this.props.cerrent_area} </h4>
							}
							{this.props.dealerTypeChart ? null : <small>Number of {this.state.data ? this.state.data.length : 0} branches</small>}
						</GridItem>
						<GridItem xs={3}>
							{/* <div className="W100 txt-r m-b-1"> */}
							{/* <b>% Quarter {this.props.quarter_number == 2 ? "2(Current)" : this.props.quarter_number == 1 ? 4 : this.props.quarter_number - 1}</b> */}
							<GridContainer justify="center">
								<GridItem> 3/FY21 </GridItem>
								<GridItem> 4/FY21 </GridItem>
								<GridItem> 1/FY21 </GridItem>
							</GridContainer>
							{/* </div> */}
						</GridItem>
					</GridContainer>
					{
						this.state.data ?
							<FadeIn>
								{this.state.data.map((row) => {
									var a = []
									if (this.props.dealerTypeChart) {
										a.push(<small className="txt-c-dorg txt-r" >Target NPS-OS ({this.props.mid_nps}%)</small>)
									} else {
										if (row.nps_os_all_nissan > this.props.mid_nps) {
											if (row.nps_os_current < row.nps_os_all_nissan && !show_nw_nps_os) {
												show_nw_nps_os = true
												a.push(<small className="txt-c-dorg txt-r" >Target NPS-OS ({row.nps_os_all_nissan}%)</small>)
												a.push(<hr className="hr-s1-m-0 bg-c-dorg" />)
											}
											if (row.nps_os_current < this.props.mid_nps && !show_middle) {
												show_middle = true
												a.push(this.renderLabelData("Middle NPS-OS : " + this.props.cerrent_area, this.state.mid_count, this.props.mid_nps, this.props.mid_nps, false, true))
											}
										} else {
											if (row.nps_os_current < this.props.mid_nps && !show_middle) {
												show_middle = true
												a.push(this.renderLabelData("Middle NPS-OS : " + this.props.cerrent_area, this.state.mid_count, this.props.mid_nps, this.props.mid_nps, false, true))
											}
											if (row.nps_os_current < row.nps_os_all_nissan && !show_nw_nps_os) {
												show_nw_nps_os = true
												a.push(<small className="txt-c-dorg txt-r" >Target NPS-OS ({row.nps_os_all_nissan}%)</small>)
												a.push(<hr className="hr-s1-m-0 bg-c-dorg" />)
											}
										}
									}

									a.push(this.renderLabelData(row.name, row.count_100_per, row.nps_os_current, row.nps_os_old, row.isPassNPS))
									return a
								})}
								{/* <hr className="hr-s1-m-0 bg-c-dorg" />  */}
							</FadeIn>
							: null
					}

				</div>
			</div>
		);
	}
}

export default Chart2;